import { render, staticRenderFns } from "./CampaignPayments.vue?vue&type=template&id=705821b2&"
import script from "./CampaignPayments.vue?vue&type=script&lang=js&"
export * from "./CampaignPayments.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPayments.vue?vue&type=style&index=0&id=705821b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports